import React, { useContext, useMemo } from "react";
import { ScrollView, View } from "react-native";
import { getMessageLog } from "../../backend/exploration/Exploration";
import { PlayerContext } from "../../backend/PlayerContext";
import { Markdown } from "../utility/Markdown";

export function PlayerMessageLog() {
  const playerContext = useContext(PlayerContext);
  const messageLog = getMessageLog(playerContext);
  return useMemo(
    () => (
      <ScrollView>
        {messageLog.map((logItem) => {
          // @ts-ignore In previous versions logItem was a string
          const key: string = logItem?.id ?? logItem;
          return (
            <View key={key}>
              <Markdown
                accessibilityLabel={
                  logItem?.accessibleMessage ?? logItem?.message
                }
              >
                {logItem?.message ?? logItem}
              </Markdown>
            </View>
          );
        })}
      </ScrollView>
    ),
    [messageLog.map((logItem) => logItem?.id ?? logItem).join()],
  );
}
